export const fakeStartup = process.env.REACT_APP_FAKE_STARTUP === 'true'
export const singleChallenge = !!process.env.REACT_APP_CHALLENGE_ID
